const DonationApi = {
  donation: [
    {
      id: 1,
      img: "https://i.ibb.co/715v32G/5836.jpg",
      description:
        "Free education is education funded through government spending or charitable organizations rather than government spending ",

      title: "Free Education",
      price: "1000",
    },
    {
      id: 2,
      img: "https://i.ibb.co/715v32G/5836.jpg",
      description:
        "Free education is education funded through government spending or charitable organizations rather than",

      title: "Distribution Of Food Items",
      price: "2000",
    },
    {
      id: 3,
      img: "https://i.ibb.co/715v32G/5836.jpg",
      description:
        "Free education is education funded through government spending or charitable organizations rather than",

      title: "Food Assistance To Flood Victims",
      price: "500",
    },
    {
      id: 4,
      img: "https://i.ibb.co/715v32G/5836.jpg",
      description:
        "Free education is education funded through government spending or charitable organizations rather than",

      title: "Mosque Construction Project",
      price: "100",
    },
  ],
};
export default DonationApi;
